import { AppThunk } from 'src/state/common';

import {
    APIgetMe,
    APIlogin,
    APIsignup,
    APIcreateTenant,
    APIverifyEmail,
    APIacceptInvitation,
    APIupdateProfile,
    APIdeleteTenant,
    APIupdateTenant
} from '../apis';
import { CreateTenantForm, LoginForm, SignupForm, UpdateProfileForm } from '../types';

import { AuthActions } from './index';

import { storage } from '@/utils';

const getUserAuthInfo = (): AppThunk => async (dispatch, getState): Promise<void> => {
    try {
        const { auth } = getState();
        const user = await APIgetMe();
        dispatch(AuthActions.setUser(user));
        if (!auth.tenant) {
            const firstTenantActive = user.tenants.find((t) => t.status === 'active');
            if (!firstTenantActive) return;
            dispatch(AuthActions.setTenant(firstTenantActive.tenant));
        }
    } catch (error) {
        dispatch(AuthActions.logout());
    }
};

const login = (data: LoginForm): AppThunk => async (dispatch): Promise<void> => {
    const token = await APIlogin(data);
    storage.setToken(token, data.rememberMe);
    await dispatch(getUserAuthInfo());
};

const signup = (data: SignupForm, invitationToken: string | null): AppThunk => async (dispatch, getState): Promise<void> => {
    const token = await APIsignup(data, invitationToken);
    storage.setToken(token);
    if (invitationToken) {
        dispatch(AuthActions.setInvitationToken(null));
    }
    await dispatch(getUserAuthInfo());
};

const updateProfile = (data: UpdateProfileForm): AppThunk => async (dispatch): Promise<void> => {
    await APIupdateProfile(data);
    await dispatch(getUserAuthInfo());
};

const createTenant = (data: CreateTenantForm): AppThunk => async (dispatch): Promise<void> => {
    const tenant = await APIcreateTenant(data);
    dispatch(AuthActions.setTenant(tenant));
    await dispatch(getUserAuthInfo());
};

const updateTenant = (tenantId: string, data: CreateTenantForm): AppThunk => async (dispatch, getState): Promise<void> => {
    const { auth } = getState();
    const tenant = await APIupdateTenant(tenantId, data);
    if (auth.tenant.id === tenantId) {
        dispatch(AuthActions.setTenant(tenant));
    }
    await dispatch(getUserAuthInfo());
};

const deleteTenant = (tenantId: string): AppThunk => async (dispatch, getState): Promise<void> => {
    const { auth } = getState();
    await APIdeleteTenant(tenantId);
    if (auth.tenant.id === tenantId) {
        dispatch(AuthActions.setTenant(undefined));
    }
    await dispatch(getUserAuthInfo());
};

const verifyEmail = (token: string): AppThunk => async (dispatch): Promise<void> => {
    await APIverifyEmail(token);
    await dispatch(getUserAuthInfo());
};

const acceptInvitation = (token: string, forceAcceptOtherEmail?: boolean): AppThunk => async (dispatch): Promise<void> => {
    const tenant = await APIacceptInvitation(token, forceAcceptOtherEmail);
    dispatch(AuthActions.setTenant(tenant));
    await dispatch(getUserAuthInfo());
};

export default {
    acceptInvitation,
    getUserAuthInfo,
    verifyEmail,
    createTenant,
    deleteTenant,
    updateTenant,
    login,
    signup,
    updateProfile
};
